module.exports = __webpack_public_path__ + "static/media/file-word-solid.e21f5919.svg";